/*
 * File: /src/router/routes/leadSources.js
 * Created Date: Wednesday November 6th 2024
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Wednesday, 6th November 2024 8:23:02 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2024 AdBase, Inc.
 */

const ListSources = () =>
  import(
    /* webpackChunkName: "LeadSources" */ 'src/components/Dashboard/Views/LeadSources/LeadSourceList.vue'
  );

const EditSource = () =>
  import(
    /* webpackChunkName: "LeadSources" */ 'src/components/Dashboard/Views/LeadSources/LeadSourceEdit.vue'
  );

export const leadSourceRoutes = [
  {
    path: 'lead-sources/',
    name: 'Lead Sources',
    component: ListSources,
  },
  {
    path: 'lead-sources/add',
    name: 'Add New Lead Source',
    component: EditSource,
  },
  {
    path: 'lead-sources/edit/:id',
    name: 'Edit Lead Sources',
    component: EditSource,
  },
];
